import { render, staticRenderFns } from "./add-post-graduate.vue?vue&type=template&id=1cbf3cc9&scoped=true"
import script from "./add-post-graduate.vue?vue&type=script&lang=js"
export * from "./add-post-graduate.vue?vue&type=script&lang=js"
import style0 from "./add-post-graduate.vue?vue&type=style&index=0&id=1cbf3cc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbf3cc9",
  null
  
)

export default component.exports